module.exports = __webpack_public_path__ + "img/hc.87e28748.png";